import { styled } from "@mui/material/styles";
import { TabList, TabListProps } from "@mui/lab";

export function TabsStyledV2(props: TabListProps) {
  const TabsStyledV2Component = styled((innerProps: TabListProps) => <TabList {...innerProps} />)(
    ({ theme }) => ({
      minHeight: "35px !important",
      "& .MuiTab-root": {
        textTransform: "uppercase !important",
        minHeight: "35px !important",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        flex: 1,
        maxWidth: "100%",
        padding: "8px",
        fontSize: "14px",
        fontWeight: "700",
        "&.Mui-selected": {
          color: theme.myTheme.colors.foreground100,
          backgroundColor: theme.myTheme.colors.gray500,
        },
      },
    })
  );

  return <TabsStyledV2Component {...props} />;
}
